import { Button } from '~/components/shadcn/button.tsx';

type ButtonAuthProps = {
	dataTestId?: string;
	disabled?: boolean;
	text: string;
	type?: 'button' | 'reset' | 'submit';
};

export function ButtonAuth({ dataTestId, disabled, text, type = 'submit' }: ButtonAuthProps) {
	return (
		<Button className="w-full" data-test-id={dataTestId} disabled={disabled} type={type} variant="default">
			{text}
		</Button>
	);
}
